import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dropdown--mobile",
  "use": "icon-dropdown--mobile-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-dropdown--mobile\"><path d=\"M0 36.381 3.619 40 39.807 3.812 36.188.192 0 36.383Z\" fill=\"#FA6400\" /><path d=\"M34.882 0v38.383H40V0h-5.118Z\" fill=\"#FA6400\" /><path d=\"M1.617 0v5.118H40V0H1.617Z\" fill=\"#FA6400\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol